export default __webpack_public_path__ + "static/media/hero_banner.ea53763c.jpg";